import { BehaviorSubject, distinctUntilChanged, Observable, ReplaySubject, Subject } from 'rxjs';
import {DoorCorners, ProductsMap, RenderResult, ScenarioImage, VisualizedScenarioImage} from "./types";

export interface VisualizeEngineOptions {
  drawGlassLayer?: boolean;
  enabledShadowProfiles?: boolean;
  enableShadowInpainting?: boolean;
  compositionOperator?: string
  shadowInpaintingAlpha?: number;
  calculateDoorBrightness?: boolean;
}

export abstract class VisualizeEngine {
  protected isVisualizationInProgress$ = new BehaviorSubject<boolean>(true);
  protected currentScenario$ = new ReplaySubject<VisualizedScenarioImage>(1);
  protected onEngineError$ = new Subject<Error>();

  renderResult$ = new BehaviorSubject<RenderResult | undefined>(undefined);

  onEngineError(): Observable<Error> {
    return this.onEngineError$.asObservable();
  }

  onRenderedScenario(): Observable<RenderResult | undefined> {
    return this.renderResult$.asObservable();
  }

  isVisualizationInProgress(): Observable<boolean> {
    return this.isVisualizationInProgress$.asObservable().pipe(distinctUntilChanged());
  }

  getCurrentScenario(): Observable<VisualizedScenarioImage> {
    return this.currentScenario$.asObservable();
  }

  abstract prepare(): void;

  abstract init(options: VisualizeEngineOptions): void;

  abstract updateCanvas(canvas: HTMLCanvasElement): void;

  abstract convertScenarioPositionToScreenPosition(corners: Array<DoorCorners>): Array<DoorCorners>;

  abstract convertScreenPositionToScenarioPosition(corners: Array<DoorCorners>): Array<DoorCorners>;

  abstract drawScenario(scenario: ScenarioImage): void;

  abstract getCurrentScenarioValue(): VisualizedScenarioImage | undefined;

  abstract drawProducts(products: ProductsMap): void;

  abstract setRenderDoor(shouldRenderDoor: boolean): void;

  abstract flipDoor(doorCornerId: number): void;

  abstract getVisualizationInOriginalSize(): Promise<HTMLCanvasElement | undefined>;
}
